import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const FormBox = styled.div`
  padding: 10px 0;
  margin-bottom: 20px;
  display: grid;
  gap: 30px;
  label[class^='SliderDateField'] {
    width: 80px !important;
  }
  ${media.md`
    padding: 20px;
    border: 1px solid #efefef;
    border-radius: 3px;
    margin-bottom: 20px;
`};
`;

export const Section = styled.div`
  padding-bottom: 200px;
`;

export const ReturnMessage = styled.p`
  margin-bottom: 0;
  font-size: 13px;
  padding-top: 5px;
  padding-left: 17px;
  width: 100%;
  text-align: left;
  ${media.md`
    width: 50%;
  `}
`;

export const AdditionNotesWrapper = styled.div`
  padding: 0 26px;
  ${media.md`
    padding: 0 0;
  `}
`;

export const FieldContainer = styled.div`
  margin-top: 15px;
`;

export const FieldSpacer = styled.div`
  margin-bottom: -10px;
  display: flex;
  justify-content: flex-end;
`;

export const FlexContainer = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const DepositAmount = styled.p`
  display: inline;
  font-weight: 800;
  font-size: unset;
`;

export const DepositDescription = styled.p`
  display: inline;
`;

export const InputContainer = styled.div`
  max-width: 100%;
  width: 100%;
  justify-content: flex-end;
  select {
    min-height: 56px;
  }
  ${media.md`
   width: 50%;
    select {
      min-height: 46px;
    }
  `}
  padding:1rem;
`;

export const TableFormContainer = styled.div`
  margin-top: 20px;
  div[class^='DateSlider'] {
    margin: 0 -15px 0 -5px;
    ${media.md`
      margin: 0 0 0 -2px;
    `};
  }

  label[class^='SliderDateField'] {
    width: 100px;
  }

  div[class*='GuestPickerWrapper'] {
    &:after {
      content: '';
      top: calc(50% - 2px);
      border-width: 6px 4px 0px;
    }
  }
  div[class*='Popper__StyledPopper'] {
    top: 42px;
  }
`;

export const CheckboxWrapper = styled.div`
  margin: 10px 0;
  display: grid;
  grid-template-columns: 1fr;
`;
